import { render } from "./addModule.vue?vue&type=template&id=16ee5e22&scoped=true"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"

import "./addModule.vue?vue&type=style&index=0&id=16ee5e22&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ee5e22"]])

export default __exports__